/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const appointmentAvailabilityRules = sqliteTable('appointment_availability_rules', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  name: text('name'),
  provider_id: text('provider_id'),
  service_id: text('service_id'),
  days_of_week: text('days_of_week'),
  start_time: text('start_time'),
  end_time: text('end_time'),
  slot_duration_minutes: integer('slot_duration_minutes'),
  capacity_per_slot: integer('capacity_per_slot'),
  slot_type: text('slot_type'),
  effective_start_date: text('effective_start_date'),
  effective_end_date: text('effective_end_date'),
  auto_generate: integer('auto_generate'),
  generate_days_ahead: integer('generate_days_ahead'),
  notes: text('notes'),
  is_active: integer('is_active'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
